import type { Program } from 'models';
import { useEffect } from 'react';
import { Modal, message } from 'ui';
import { useCreateRequestToJoinMutation } from '../queries';
import { RequestToJoinForm } from './components';

type P = {
  isOpened: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  program: Program;
};

const CreateRequestToJoin = ({ isOpened, onCancel, onSuccess, program }: P) => {
  const {
    error: createRequestToJoinError,
    isPending: isCreatingRequestToJoin,
    isSuccess: isCreateRequestToJoinSuccess,
    mutateAsync: createRequestToJoin,
  } = useCreateRequestToJoinMutation();

  const onSubmit = async (data: { reason: string }) => {
    await createRequestToJoin({ data, programId: program.id });
  };

  useEffect(() => {
    if (createRequestToJoinError) {
      message.error('Something went wrong, please try again later.');
    }
  }, [createRequestToJoinError]);

  useEffect(() => {
    if (isCreateRequestToJoinSuccess) {
      onSuccess();
    }
  }, [isCreateRequestToJoinSuccess, onSuccess]);

  return (
    <Modal isOpened={isOpened} onCancel={onCancel} title="Why do you want to subscribe?" width="medium">
      <Modal.HugContent>
        <RequestToJoinForm loading={isCreatingRequestToJoin} onSubmit={onSubmit} />
      </Modal.HugContent>
    </Modal>
  );
};

export default CreateRequestToJoin;
